import { Component } from "react"

/* Widgets */
import { Authorization, Dashboard } from './pages'

/* JWT */
import { isExpired } from "react-jwt"

/* Modal */
import Modal from "react-modal"

/* DEFAULT CONFIG */
Modal.setAppElement("#root")


/* Entry Point */
class App extends Component {

    constructor() {
        super()

        const token = localStorage.getItem("token")

        this.state = {
            token
        }
    }

    render = () => {

        /* Fields */
        const { token } = this.state

        /* Authorization Mode */
        if (!token || isExpired(token)) {
            return <Authorization setToken={token => this.setState({ token })} />
        }

        return <Dashboard setToken={token => this.setState({ token })} />
    }
}

export default App